import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import Footer from "../components/Footer";
import "../styles/select-plan.scss";
import CTAButton from "../components/LandingPage/Common/CTAButton";
import { sendAnalyticsEvent } from '../utils/SendAnalyticsEvent';

function CableSubscribed() {
    document.title="iWantTFC - Discover | Subscribed via Cable Provider";
    const location = useLocation();
    const params = location.state;

    useEffect(() => {
        const eventProperties = {
            changePlanNotAllowedMessage: "CabSat TVE",
            paymentMethodType: params?.pm
        };
        sendAnalyticsEvent("changePlanNotAllowedRender", eventProperties, "Purchase Journey", "Discover page");
    }, []);

    return (
        <div className="body" style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/footer-bg.png)' }}>
            <Header />
            <div className="ec-container">
                <div className="text-container">
                    <p className="text-center">You are currently enjoying an active subscription.</p>
                    <p className="text-center">For assistance, email <Link to="mailto:support@iwantTFC.com">support@iwantTFC.com</Link>.</p>
                </div>
                {params?.pm &&
                    <p className="label">Current provider</p>
                }
                <p className="pm all-caps">{params?.pm}</p>
                <CTAButton link={process.env.REACT_APP_IWANTTFC_HOMEPAGE} text="Back to Home" />
            </div>
            <Footer bg="false" />
        </div>
    );
}

export default CableSubscribed;